import { Component, Input, ViewChild, ElementRef, ComponentRef, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Output } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { GeoServices } from '../../../services/geo.service';
import { Http } from '@angular/http';
import { LoaderDirective } from '../../../shared/directives/loader-directive';
import { Subscription } from 'rxjs';
import { ComponentsManagerService } from 'nm-socle-application/app/shared/services/component-manager.service';
import { FormComponentI } from 'nm-socle-application/app/shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from 'nm-socle-application/app/shared/models/internal-state-event';
import { StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';


@Component({
    selector: 'form-container',
    templateUrl: './form-container.component.html',
    styleUrls: ['./form-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FormContainerComponent extends AbstractComponent implements FormComponentI {
    public static ICON_TOP:string = 'top';
    public static ICON_BOTTOM:string = 'bottom';
    public static ICON_LEFT:string = 'left';
    public static ICON_RIGHT:string = 'right';

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();
    public closeEventSub:Subscription;
    public internalStateEventSub:Subscription;
    @Input() public misc:StateMiscArgument[] = [];

    @Input() public icon: string;
    @Input() public image: string;
    @Input() public title: string;
    @Input() public desc: string;
    @Input() public iconPosition: string = FormContainerComponent.ICON_TOP;
    @Input() public componentName: string;

    @Input() public get type(): string {
        return this.componentName;
    }
    public set type( value: string ) {
        this.componentName = value;

        this.markForCheck();
    }

    @ViewChild(LoaderDirective) public loaderHost: LoaderDirective;
    protected _compoRef:ComponentRef<Component>;

    constructor(
        protected _configService:ConfigService,
        protected _geoServices:GeoServices,
        protected _http: Http,
        protected elRef: ElementRef,
        protected _componentsManagerService: ComponentsManagerService,
        protected _cd:ChangeDetectorRef,
    ) {
        super(_cd);
    }

    public ngAfterViewInit() {
        this.initElem();

        this.markForCheck();
    }

    public initElem() {
        if(this._compoRef != undefined) {
            this._compoRef.destroy();
        }

        if(this.internalStateEventSub != undefined) {
            this.internalStateEventSub.unsubscribe();
        }

        if(this.closeEventSub != undefined) {
            this.closeEventSub.unsubscribe();
        }

        if(this.loaderHost != undefined && this.componentName != undefined) {
            this._compoRef = this._componentsManagerService.createComponent(this._compoRef, this.componentName, this.loaderHost);

            if(this._compoRef != undefined && this._compoRef.instance['internalStateEvent'] != undefined) {
                this.internalStateEventSub = this._compoRef.instance['internalStateEvent'].subscribe(evt => {
                    for(let prop in evt) {
                        // TODO : récupérer les infos du states
                        if(evt[prop] != undefined) {
                            this[prop] = evt[prop]
                        }
                    }

                    this.markForCheck();
                });
                
                this._compoRef.changeDetectorRef.detectChanges();
                this.markForCheck();
            }

            if(this._compoRef != undefined && this._compoRef.instance['closeEvent'] != undefined) {
                this.closeEventSub = this._compoRef.instance['closeEvent'].subscribe(evt => {
                    this.closeEvent.emit(evt);

                    this.markForCheck();
                });
            }

            if(this._compoRef != undefined && this._compoRef.instance['misc'] != undefined) {
                this._compoRef.instance['misc'] = this.misc;

                this.markForCheck();
            }
        }
    }

    public ngOnDestroy() {
        super.ngOnDestroy();

        if(this.internalStateEventSub != undefined) {
            this.internalStateEventSub.unsubscribe();
        }

        if(this.closeEventSub != undefined) {
            this.closeEventSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/components/form-container/form-container.component.ts